import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../../../graphql/fragments/generated/User';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GroupUsersQueryVariables = Types.Exact<{
  filters: Types.UsersFilters;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  groupId: Types.Scalars['String']['input'];
}>;


export type GroupUsersQuery = { users: { totalCount: number, edges?: Array<{ node: { uniqueId: string, isAutoSync: boolean, id: string, name?: string | null, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } }> | null, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null } };


export const GroupUsersDocument = /*#__PURE__*/ gql`
    query groupUsers($filters: UsersFilters!, $sort: [SortType!], $first: Float, $after: String, $groupId: String!) {
  users(filters: $filters, sort: $sort, first: $first, after: $after) {
    edges {
      node {
        ...User
        uniqueId
        isAutoSync(groupId: $groupId)
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${UserFragmentDoc}`;

export function useGroupUsersQuery(options: Omit<Urql.UseQueryArgs<GroupUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<GroupUsersQuery, GroupUsersQueryVariables>({ query: GroupUsersDocument, ...options });
};